var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMentorNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.75,
    cy: 50,
    r: 50,
    fill: "#E9ECEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3885_13015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6501 67.6H57.2501C56.2501 70.2 53.7501 72 50.7501 72C47.8501 72 45.2501 70.2 44.2501 67.6H50.6501ZM67.5501 58.4C60.3501 54.3 65.3501 42.1 60.8501 35.8C59.0501 33.3 56.5501 31.8 53.7501 31.3V31C53.7501 29.4 52.4501 28 50.7501 28C49.1501 28 47.7501 29.3 47.7501 31V31.3C44.9501 31.9 42.3501 33.4 40.6501 35.8C36.1501 42.1 41.1501 54.3 33.9501 58.4C31.3501 59.8 31.4501 64.5 34.6501 64.8H50.7501H50.8501H66.9501C70.0501 64.5 70.1501 59.9 67.5501 58.4Z",
    fill: "#B2B2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3885_13015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 44,
    fill: "white",
    transform: "translate(31.75 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMentorNotifications);
export default __webpack_public_path__ + "static/media/EmptyMentorNotifications.a2ee22eb4da0e3d4f97212a21c98a4ee.svg";
export { ForwardRef as ReactComponent };